import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Home from "./components/Home";
import About from "./components/About";
import Career from "./components/Career";
import Contact from "./components/Contact";
import Portfolio from "./components/Portfolio";
import Privacy from "./components/Privacy";
import Gdpr from "./components/Gdpr";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./components/AppInsights";
import JobForm from "./components/JobForm";

function App() {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/career" component={Career} />
          <Route path="/contact" component={Contact} />
          <Route path="/portfolio" component={Portfolio} />
          {/* <Route path="/privacy-policies" component={Privacy} /> */}
          <Route path="/privacy-gdprs" component={Gdpr} />
          <Route path="/job-form" component={JobForm} />
        </Switch>
      </BrowserRouter>
    </AppInsightsContext.Provider>
  );
}

export default App;
